import {
  ConfirmationBox,
  DatePickerWithInput,
  HeadingGroup,
  ModalLayout,
  NavGroup,
  Pagination,
  // SearchFilters,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import Style from "../../Billings/staffBilling.module.scss";
import { Link } from "react-router-dom";
import useDeliveryCompleted from "./useDeliveryCompleted";
import DeliverySlip from "../../EmployeeRecheck/DeliveryRecheck/DeliverySlip/DeliverySlip";
import DeliveryChallanPrint from "../../EmployeeRecheck/DeliveryRecheck/DeliveryChellan/DeliveryChellan";
import OfficeSlip from "./OfficeSlip/OfficeSlip";
import StockReceipt from "./StockReceipt/StockReceipt";
import { Table } from "../../Global/Table";

const DeliveryCompleted = () => {
  const {
    tabNavs,
    activeTab,
    paginationOptions,
    deliveryList,
    isFetching,
    tableFields,
    showEditModal,
    queryState,
    date,
    handleDateChange,
    handleSearch,
    handleSort,
    handlePageSize,
    handlePagination,
    updateEstimateFields,
    handleEditColumnsClick,
    refetch,
    getRow,
    handlePrintSlip,
    handlePrintChellan,
    handleOrderPrintSlip,
    handleOrderPrintChellan,
    slipRef,
    chellanRef,
    officeSlipRef,
    stockReceiptRef,
    loadingSlip,
    loadingChellan,
    loadingStockReceipt,
    loadingOfficeSlip,
    handleStockReceiptPrint,
    handleOfficeSlipPrint,
    handleSelect,
    selectedRows,
    setSelectedSlipIds,
  } = useDeliveryCompleted();
  return (
    <div>
      <HeadingGroup title={"Delivery Completed"} className={`pro-mb-4`} />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className={`${Style.main_container}`}>
          <NavGroup navigations={tabNavs} type={"type-2"} Link={Link} />
        </div>
        <div className="col-auto pro-pt-3 ">
          <div className="row gx-2 gy-2 flex-fill">
            <div className={`col-auto`}>
              <div className="input-wrap">
                <input
                  type="text"
                  onChange={handleSearch}
                  placeholder="Search Gli Number"
                  className={`pro-input icon-r lg search-input ${Style.search_table}`}
                />
                <span className="pro-icon">
                  {<span className="material-symbols-outlined">search</span>}
                </span>
              </div>
            </div>
            {/* <div className={`col-auto`}>
                <button
                  className="pro-btn pro-btn-outline"
                  onClick={handleEditColumnsClick}
                >
                  Edit Columns
                </button>
              </div> */}
            <div className={`col-auto`}>
              <DatePickerWithInput
                CalendarOutlineIcon={
                  <span className="material-symbols-outlined">
                    calendar_month
                  </span>
                }
                range={true}
                initialValue={date}
                onDateChange={handleDateChange}
              ></DatePickerWithInput>
            </div>
            {selectedRows?.length > 0 && (
              <>
                <div className={`col-auto`}>
                  <button
                    className={`${Style.Print_btn} pro-btn pro-items-center pro-btn-outline`}
                    onClick={handleStockReceiptPrint}
                    disabled={loadingStockReceipt}
                  >
                    <span className="material-symbols-outlined">list_alt</span>
                    <span>{"Print Stock Receipt"}</span>
                  </button>
                </div>
                <div className={`col-auto`}>
                  <button
                    className={`${Style.Print_btn} pro-btn pro-items-center pro-btn-outline`}
                    onClick={handleOfficeSlipPrint}
                    disabled={loadingOfficeSlip}
                  >
                    <span className="material-symbols-outlined">apartment</span>
                    <span>{"Print Office Slip"}</span>
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
        <Table
          multiSelect={activeTab === "recheck"}
          data={deliveryList?.data?.data || []}
          uniqueID={"id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          editIcon={<span className="material-symbols-outlined">print</span>}
          deleteIcon={<span className="material-symbols-outlined">print</span>}
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          perpage={queryState?.currentPageSize}
          assignable={false}
          showCheckBox={true}
          handleDelete={
            activeTab === "orders"
              ? handleOrderPrintChellan
              : handlePrintChellan
          }
          deletable={false}
          editText={loadingSlip ? "Printing Slip...." : "Print Slip"}
          deleteText={loadingChellan ? "Printing Chellan...." : "Print Chellan"}
          handleEdit={
            activeTab === "orders" ? handleOrderPrintSlip : handlePrintSlip
          }
          clear={queryState?.clear}
          handleSelect={handleSelect}
          tabFilter={true}
        />
        {deliveryList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={queryState?.currentPage}
            totalPageCount={Math.ceil(
              deliveryList?.data?.total_count / queryState?.currentPageSize,
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={deliveryList?.data?.fields}
              moduleId={deliveryList?.data?.module_id}
              updateData={updateEstimateFields}
            />
          </div>
        </ModalLayout>
        <div
          style={{
            position: "fixed",
            opacity: "0",
            visibility: "hidden",
            height: "0",
            width: "0",
          }}
        >
          <DeliverySlip slipRef={slipRef} isCompleted />
          <DeliveryChallanPrint chellanRef={chellanRef} isCompleted />
          <OfficeSlip officeSlipRef={officeSlipRef} />
          <StockReceipt stockPrintRef={stockReceiptRef} />
        </div>
      </div>
    </div>
  );
};

export default DeliveryCompleted;
